/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';
// @ts-ignore
import type { DailyOrderMetrics } from './DailyOrderMetrics';
// @ts-ignore
import {
// @ts-ignore
    DailyOrderMetricsFromJSON,
// @ts-ignore
    DailyOrderMetricsFromJSONTyped,
// @ts-ignore
    DailyOrderMetricsToJSON,
} from './DailyOrderMetrics';

/**
 * 
 * @export
 * @interface DailyOrderMetricsResult
 */
export interface DailyOrderMetricsResult {
    /**
     * Raw metrics grouped by currency.
     * @type {Array<DailyOrderMetrics>}
     * @memberof DailyOrderMetricsResult
     */
    metrics: Array<DailyOrderMetrics>;
    /**
     * Metrics converted into a single currency.
     * @type {Array<DailyOrderMetrics>}
     * @memberof DailyOrderMetricsResult
     */
    summary: Array<DailyOrderMetrics>;
    /**
     * Total number of orders across all summary entries.
     * @type {number}
     * @memberof DailyOrderMetricsResult
     */
    totalCount: number;
    /**
     * 
     * @type {Amount}
     * @memberof DailyOrderMetricsResult
     */
    totalAmount: Amount;
    /**
     * 
     * @type {number}
     * @memberof DailyOrderMetricsResult
     */
    supplierCount: number;
    /**
     * 
     * @type {number}
     * @memberof DailyOrderMetricsResult
     */
    storeCount: number;
}

/**
 * Check if a given object implements the DailyOrderMetricsResult interface.
 */
// @ts-ignore
export function instanceOfDailyOrderMetricsResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "metrics" in value;
    isInstance = isInstance && "summary" in value;
    isInstance = isInstance && "totalCount" in value;
    isInstance = isInstance && "totalAmount" in value;
    isInstance = isInstance && "supplierCount" in value;
    isInstance = isInstance && "storeCount" in value;

    return isInstance;
}

// @ts-ignore
export function DailyOrderMetricsResultFromJSON(json: any): DailyOrderMetricsResult {
    return DailyOrderMetricsResultFromJSONTyped(json, false);
}

// @ts-ignore
export function DailyOrderMetricsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyOrderMetricsResult {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metrics': ((json['metrics'] as Array<any>).map(DailyOrderMetricsFromJSON)),
        'summary': ((json['summary'] as Array<any>).map(DailyOrderMetricsFromJSON)),
        'totalCount': json['total_count'],
        'totalAmount': AmountFromJSON(json['total_amount']),
        'supplierCount': json['supplier_count'],
        'storeCount': json['store_count'],
    };
}

// @ts-ignore
export function DailyOrderMetricsResultToJSON(value?: DailyOrderMetricsResult | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metrics': ((value.metrics as Array<any>).map(DailyOrderMetricsToJSON)),
        'summary': ((value.summary as Array<any>).map(DailyOrderMetricsToJSON)),
        'total_count': value.totalCount,
        'total_amount': AmountToJSON(value.totalAmount),
        'supplier_count': value.supplierCount,
        'store_count': value.storeCount,
    };
}

